import { Box, Flex, Image, Link, Text } from '@chakra-ui/react';

import { Esign } from '../../../../assets/Images';
import { PaperworkType, TtNewBankEnum } from '../../../../gql/generated/graphql';
import getSearchPhoneNumbers from '../../../../utils/getSearchPhoneNumbers';
import { isBooleanSetAndFalse } from '../../../../utils/helpers';
import { DealWithFarthestState } from '../../utils';
import SignButtons from '../SignButtons';

const SentForSignatures = ({ deal }: { deal?: DealWithFarthestState }) => {
  const phoneNumber = getSearchPhoneNumbers();

  if (
    !deal ||
    isBooleanSetAndFalse(deal.signing_on_com) ||
    deal.paperwork_type !== PaperworkType.LeaseEnd ||
    deal.financial_info?.bank_slug === TtNewBankEnum.Iccu
  ) {
    return (
      <Text>
        Your advisor will be reaching out soon to go over the signing process and review any
        requirements. If you have any questions or need assistance, please don’t hesitate to contact
        us at <Link href={`tel:+1-${phoneNumber}`}>{phoneNumber}</Link>. We’re excited to guide you
        through the rest of your buyout process!
        <br />
        <br />
        (If your online application comes in outside of our business hours, we’ll contact you first
        thing the next business day.)
      </Text>
    );
  }

  return (
    <>
      <Box>
        <Flex alignItems="flex-start" mb={4} direction={{ base: 'column', md: 'row' }}>
          <Image display={{ base: 'none', md: 'block' }} src={Esign} maxW="80px" mr={2} mb={0} />
          <Text>
            Your documents are being prepared. Once they're ready, you can review and digitally sign
            them by following the button below.
          </Text>
        </Flex>
        <Text mb={4}>
          Rest assured, our Signing service prioritizes the security and privacy of your
          information. We've implemented robust security measures to safeguard your data throughout
          the signing process, ensuring a secure and confidential experience for you.
          {deal.signing_on_com && (
            <>
              {' '}
              Please note,{' '}
              <Text as="span" color="leaseEndRed" fontWeight="bold">
                DOCUMENTS EXPIRE AT MIDNIGHT MOUNTAIN TIME.
              </Text>
            </>
          )}
        </Text>
        <SignButtons deal={deal} />
      </Box>
    </>
  );
};

export default SentForSignatures;
